<template>
  <v-card class="mx-0 px-0">
    <v-card-title class="success white--text my-0 py-0">
      <v-container class="fill-heigth fill-width my-0 py-0 mr-0 pr-0">
        <v-row class="d-flex align-center justify-end">
          <v-col cols="12" md="8">
            <span class="text-h5">Pagamento Honorários</span><br>
          </v-col>
          <v-spacer />
          <v-col cols="12" md="4">
            <v-simple-table id="tablepgto" dark v-if="mostrarPagamentosHonorarios()">
              <tbody>
                <tr>
                  <td style="max-width: 50px;" class="text-left"><h5 class="font-weight-black">Previsto</h5></td>
                  <td class="text-right"><h5 class="font-weight-black"> {{ valorTotalPrevisto | currency }} </h5></td>
                </tr>
                <tr>
                  <td style="max-width: 80px;" class="text-left"><h5 class="font-weight-black">Recebido</h5></td>
                  <td class="text-right"><h5 class="font-weight-black"> {{ valorTotalPago | currency }}</h5></td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card-title>
    <v-card-text class="mx-0 px-1">
      <v-container
        v-if="!mostrarPagamentosHonorarios()"
        class="fill-heigth fill-width d-flex justify-center align-self-center"
      >
        <view-sem-dados msg="Indisponível"></view-sem-dados>
      </v-container>
      <v-container class="fill-heigth fill-width" v-else>

        <v-row
          align="center"
          class="mx-0 my-3 py-0 px-0"
        >
            <files-view ref="filesView" :processo_id="processo_id"></files-view>
            <v-spacer />
            <v-tooltip top dark color="success darken-4">
              <template v-slot:activator="{ on }">
                <v-btn color="success" v-on="on" fab x-small dark @click="addParcela()" v-show="permitirAlteracaoPagamento()">
                  <v-icon>mdi-plus-thick</v-icon>
                </v-btn>
              </template>
              <span class="white--text text--darken-1 subtitle-2">Inserir Parcela</span>
            </v-tooltip>
         
        </v-row>

        <v-row v-if="!formParcelasAtivas.length" style="min-height: 150px">
          <v-container
            class="fill-heigth fill-width d-flex justify-center align-self-center"
          >
            <view-sem-dados></view-sem-dados>
          </v-container>
        </v-row>
        <v-row
          v-else
          v-show="isUpdateWatchArray"
          v-for="(item, index) in $v.formParcelasAtivas.$each.$iter"
          :key="index"
        >
          <v-col cols="1">
            <v-tooltip top dark color="success darken-4">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  dark
                  fab
                  color="success"
                  x-small
                  @click="trashParcela(item.$model)"
                  v-show="permitirAlteracaoPagamento()"
                >
                  <v-icon style="font-size: 14px">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span class="white--text text--darken-1 subtitle-2">Excluir Parcela</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" md="1">
            <v-text-field
              v-model="item.nr_parcela.$model"
              :error-messages="validacaoForm(item.nr_parcela, '')"
              :label="index==0?'Parcela':null"
              autocomplete="disabled"     
              :disabled="!permitirAlteracaoPagamento()"         
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-mask="'##/##/####'"
              v-model="item.dt_prevista.$model"
              :error-messages="validacaoForm(item.dt_prevista, '')"
              :label="index==0?'Data Previsto':null"
              autocomplete="disabled"
              :disabled="!permitirAlteracaoPagamento()"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <VuetifyMoney
              v-model="item.vl_previsto.$model"              
              :error-messages="validacaoForm(item.vl_previsto, '')"
              v-bind:label="index==0?'Valor Previsto':null"
              autocomplete="nope"
              :disabled="!permitirAlteracaoPagamento()"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-mask="'##/##/####'"
              v-model="item.dt_pagamento.$model"
              :error-messages="validacaoForm(item.dt_pagamento, '')"
              :label="index==0?'Data Recebido':null"
              autocomplete="disabled"
              :disabled="!permitirAlteracaoPagamento()"
            ></v-text-field>  
          </v-col>
          <v-col cols="12" md="2">
            <VuetifyMoney
              v-model="item.vl_pagamento.$model"
              :error-messages="validacaoForm(item.vl_pagamento, '')"
              v-bind:label="index==0?'Valor Recebido':null"
              autocomplete="nope"
              :disabled="!permitirAlteracaoPagamento()"
            />
          </v-col>
          <v-divider/>
        </v-row>  
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>


import { mapMutations } from "vuex";
import { required, requiredIf, helpers, minValue } from "vuelidate/lib/validators";
import validacaoForm from '@/mixins/validacaoForm'
import utils from "@/mixins/utils";
import VuetifyMoney from "@/components/Inputs/VuetifyMoney.vue";
import { ParcelaPagamentoModel } from './_model/index'
import ViewSemDados from '@/views/Comum/SemDados'
import FilesView from '@/views/OrquestraFiles/FilesView.vue'
import validaProcesso from '@/utils/validaProcesso'
import validaUsuario from '@/utils/privilegiosUsuario'
import moment from 'moment';

const dateValid = function(value) {
  if (!helpers.req(value)) return true
  return moment(value, ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY HH:mm", "DD/MM/YYYY"]).isValid()
}

const dateMinProvisaoValidate = function(value, vm) {
  if (!vm || !vm.status) return true
  if (!validaProcesso.exigirDataProvisaoPagamento(vm.status)) return true  
  if (!moment(value, ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY HH:mm", "DD/MM/YYYY"], true).isValid()) return true 
  let dateContexto = moment(vm.data_indenizacao, ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY HH:mm", "DD/MM/YYYY"], true).format('YYYY-MM-DD')//.subtract(6, 'months').format('YYYY-MM-DD')
  let dateValue = moment(value, ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY HH:mm", "DD/MM/YYYY"], true).format('YYYY-MM-DD')
  if (moment(dateValue).isBefore(dateContexto)) return false
  return true  
}

const dateMaxProvisaoValidate = function(value, vm) {
  if (!vm || !vm.status) return true
  if (!validaProcesso.exigirDataProvisaoPagamento(vm.status)) return true  
  if (!moment(value, ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY HH:mm", "DD/MM/YYYY"], true).isValid()) return true 
  let dateContexto = moment(vm.data_indenizacao, ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY HH:mm", "DD/MM/YYYY"], true).add(1, 'years').format('YYYY-MM-DD')
  let dateValue = moment(value, ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY HH:mm", "DD/MM/YYYY"], true).format('YYYY-MM-DD')
  if (moment(dateValue).isAfter(dateContexto)) return false
  return true  
}

const dateMinPagamentoValidate = function(value, vm) {
  if (!vm || !vm.status) return true
  if (!validaProcesso.exigirDataPagamento(vm.status)) return true
  if (!moment(value, ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY HH:mm", "DD/MM/YYYY"], true).isValid()) return true
  let dateContexto = moment(vm.data_indenizacao, ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY HH:mm", "DD/MM/YYYY"], true).format('YYYY-MM-DD')//.subtract(6, 'months').format('YYYY-MM-DD')
  let dateValue = moment(value, ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY HH:mm", "DD/MM/YYYY"], true).format('YYYY-MM-DD')
  if (moment(dateValue).isBefore(dateContexto)) return false
  return true 
}

const dateMaxPagamentoValidate = function(value, vm) {
  if (!vm || !vm.status) return true
  if (!validaProcesso.exigirDataPagamento(vm.status)) return true
  if (!moment(value, ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY HH:mm", "DD/MM/YYYY"], true).isValid()) return true
  let dateContexto = moment(vm.data_indenizacao, ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY HH:mm", "DD/MM/YYYY"], true).add(1, 'years').format('YYYY-MM-DD')
  let dateValue = moment(value, ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY HH:mm", "DD/MM/YYYY"], true).format('YYYY-MM-DD')
  if (moment(dateValue).isAfter(dateContexto)) return false
  return true 
}



export default {
  name: 'Parcelas_Paramento',
  props: {
    processo_id: {
      type: Number,
      required: true
    },
    parcelas: {
      type: Array,
      required: true
    },
    status: {
      required: true
    },
    data_indenizacao: {
      required: false
    }
  },
  components: {VuetifyMoney, ViewSemDados, FilesView},
  mixins:[validacaoForm, utils],
  data() {
    return {
      loading: false,
      isUpdateWatchArray: true,
      localParcelas: [],
    }
  },
  validations: {
    formParcelasAtivas: {
      $each: {
        nr_parcela: {required, errors: []},
        dt_prevista: {
          required, 
          dateValid, 
          dateMinProvisaoValidate, 
          dateMaxProvisaoValidate, 
          errors: []},
        vl_previsto: { 
          required, 
          minValue: minValue(10),
          errors: []},
        dt_pagamento: {
          required: requiredIf(item => validaProcesso.exigirDataPagamento(item.status)),
          dateValid,
          dateMinPagamentoValidate,
          dateMaxPagamentoValidate,
          errors: []
        },
        vl_pagamento: { 
          required: requiredIf(item => validaProcesso.exigirDataPagamento(item.status)),
          minValue: minValue(10),
          errors: [] 
        },
      }
    }
  },
  created() {
    this.localParcelas = this.parcelas
  },
  watch: {
    async parcelas (newValue, oldValue) {
      if (newValue != oldValue) { 
        this.isUpdateWatchArray = false
        this.localParcelas = JSON.parse(JSON.stringify(newValue))
        await setTimeout(() => {
          this.isUpdateWatchArray = true
        }, 50)
      }
    }
  },
  methods: {
    ...mapMutations({
      commitErro: 'processo/SET_ERROS',
    }),

    permitirAlteracaoPagamento(){
      return validaProcesso.permissaoAlterarValorPgto(this.status)
    },

    mostrarPagamentosHonorarios() {
      if (validaUsuario.ehUsuarioAdministrador()) return true
      return false
      //return validaProcesso.mostrarPagamentosHonorarios(this.status)
    },
    
    addParcela() {
      let obj = new ParcelaPagamentoModel.parcela()
      obj.nr_parcela = this.getNumberNextBilling()
      obj.pagamentoProcesso_id = this.processo_id
      this.localParcelas.push(obj)      
    },
    getNumberNextBilling() {
      let value = null
      this.formParcelasAtivas.forEach(item => value = item.nr_parcela)
      return value + 1
    },
    ordenarParcelas(newObj) {
      newObj.sort(function(a,b) {
        return a.nr_parcela < b.nr_parcela ? -1 : a.nr_parcela > b.nr_parcela ? 1 : 0;
      })
      return newObj
    },
    trashParcela(item) {
      this.$dialog.confirm("Deseja realmente excluir Parcela?", {loader: true, okText: 'Sim', cancelText: 'Não',})
      .then(async (dialog) => {
        if (!item.id) {
          this.localParcelas.splice(item.reference, 1)
        } else {
          let parcs = this.localParcelas
          parcs[item.reference].isExcluido = true
          this.localParcelas = JSON.parse(JSON.stringify(parcs))
          this.$toaster.success('Parcela marcada para Exclusão. Clique em salvar para concretizar exclusão!');
        }
        dialog.close();
      })
      .catch((e) => {})
    },
    async validaForm () {
      this.$v.formParcelasAtivas.$touch();
      if (!this.$v.formParcelasAtivas.$invalid) {
        return true
      } else if (this.$v.formParcelasAtivas.$anyError) {
        return false
      }
    },
    gravar() {
      return new Promise((resolve, reject) => {
        if (!this.validaUmaParcelaCriada()) {
          let erro = 'Nenhuma parcela adicionada ao pagamento'
          this.commitErro({erros: erro})
          reject(erro)
        }
        var parc = JSON.parse(JSON.stringify(this.localParcelas))
        parc.forEach((item, k) => {
          if (item.dt_prevista) item.dt_prevista = this.converteDataHoraParaApi(item.dt_prevista)    
          if (item.dt_pagamento) item.dt_pagamento = this.converteDataHoraParaApi(item.dt_pagamento)
          parc[k] = Object.assign({}, item)
        })
        resolve(parc)
      })
    },
    validaUmaParcelaCriada(){
      if (this.obrigaPreencherParcelaPagamento() && !this.formParcelasAtivas.length) return false
      return true
    },
    obrigaPreencherParcelaPagamento() {
      return validaProcesso.exigirDataPagamento(this.status)
    },
    openViewComprovantesPagamento() {
      this.$refs.FilesView.openFilesView
    }
  },
  computed: {
    formParcelasAtivas: {
      get: function() {
        let newObj = this.localParcelas
        newObj = this.ordenarParcelas(newObj)
        newObj = this.localParcelas.filter( (item, index) => {
          item.reference = index
          item.data_indenizacao = this.data_indenizacao
          item.status = this.status
          if (item.dt_prevista) item.dt_prevista = this.converteDataParaView(item.dt_prevista)
          if (item.dt_pagamento) item.dt_pagamento = this.converteDataParaView(item.dt_pagamento)
          return !item.isExcluido
        })
        return newObj
      }
    },
    valorTotalPrevisto: {
      get() {
        return this.formParcelasAtivas.reduce((total, item) => total += parseFloat(item.vl_previsto) ? parseFloat(item.vl_previsto) : 0, 0)
      }
    },
    valorTotalPago: {
      get() {
        return this.formParcelasAtivas.reduce((total, item) => total += parseFloat(item.vl_pagamento) ? parseFloat(item.vl_pagamento) : 0, 0)
      }
    }
  }


}
</script>
<style scoped>
  #tablepgto {
    background-color: #26a69a;
    max-width: 350px;
  }
</style>


// WEBPACK FOOTER //
// src/views/Pagamentos/ParcelasView.vue